module.exports = __webpack_public_path__ + "img/7ff6d0d5357c2822606e563c62dc73d.3bbed3dd.jpg";